import { getItemLocalStorage, select, selectAll } from "@utils/function";
import { InformationSettingsUpdate } from "./informationSettings";

export default function ChangeCheboxInInformation() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const hideItems = urlParams.get("hideItems");
  const showItems = urlParams.get("showItems");

  if (!hideItems && !showItems) return;

  let hideItemsArray;
  if (hideItems) {
    hideItemsArray = hideItems.split(",").map(Number);
  } else if (showItems && showItems !== "all") {
    hideItemsArray = showItems.split(",").map(Number);
  } else {
    hideItemsArray = [99];
  }

  const getAllDataLayerId = selectAll("[data-layer-id]");

  getAllDataLayerId.forEach((layer) => {
    const layerId = layer.dataset.layerId;
    const id = layer.dataset.id;

    if (!hideItemsArray.includes(+id)) return;

    // hide items
    if (hideItems && CheckHideItems(layerId, true)) {
      InformationSettingsUpdate(layerId, getAllDataLayerId);

      // set input to false
      CheckboxCheck(layerId, false);
    }

    // show items
    if (showItems && showItems !== "all" && CheckHideItems(layerId, false)) {
      InformationSettingsUpdate(layerId, getAllDataLayerId);

      // set input to true
      CheckboxCheck(layerId, true);
    }

    // show all items
    if (showItems && showItems === "all") {
      const getLocalStorage = getItemLocalStorage("HQinformationSettings");

      if (!getLocalStorage) return;

      // first element from local storage
      const firstElementFromLocalstorage = getLocalStorage[0];

      if (firstElementFromLocalstorage?.checkbox) return;

      const firstElement = select(`[data-layer-id="show-all-layers"] input`);

      // click on checkbox
      firstElement.parentNode.click();
    }
  });
}

/**
 * Checkbox check
 *
 * @param {string} layerId
 * @param {boolean} type
 */
function CheckboxCheck(layerId, type) {
  const input = select(`[data-layer-id="${layerId}"] input`);
  input.checked = type;
  input.closest(".switch-container").setAttribute("aria-checked", type);
}

/**
 * Check if layer is in local storage
 *
 * @param {string} layerId
 */
function CheckHideItems(layerId, type) {
  const getLocalStorage = getItemLocalStorage("HQinformationSettings");

  if (!getLocalStorage) return;

  const checkIfExist = getLocalStorage.find(
    (item) => item.layer === layerId && item.checkbox === type
  );

  return checkIfExist;
}
